import { render, staticRenderFns } from "./SiliconStripes.vue?vue&type=template&id=1461bb5c"
import script from "./SiliconStripes.vue?vue&type=script&lang=js"
export * from "./SiliconStripes.vue?vue&type=script&lang=js"
import style0 from "./SiliconStripes.vue?vue&type=style&index=0&id=1461bb5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports